<template>
  <div class="form-files-list" :class="{'form-files-list--folder': folders}">
    <div class="file" v-for="({ file, name }, i) in files" :key="i">
      <div class="file__content">
        <div class="icon">
          <img src="@/assets/icons/file-primary-blue.svg" alt="" />
        </div>
        <div class="name">{{ name }}</div>
      </div>
      <img @click="remove(i)" class="remove" src="@/assets/icons/close-dark.svg" alt="" />
      <select v-if="folders" class="folders-select" :model-value="file.folder" @change="changeFolder(i, $event.target.value)" :placeholder="$t('ModalMaterialsUpload.folderPlaceholder')">
        <option :value="null">{{ $t('ModalMaterialsUpload.folderPlaceholder') }}</option>
        <option :value="folder.id" v-for="folder in folders" :key="folder.id">{{ folder.name }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'FileList',
  props: {
    files: Array,
  },
  data() {
    return {
      folder: null,
    }
  },
  computed: {

    ...mapState('folders', ['folders']),
  },
  methods: {
    changeFolder(index, folder) {
      this.change(index, 'folder', folder);
    },
    change(index, key, value) {
      this.$emit('change', {
        index,
        file: {
          ...this.files[index],
          [key]: value,
        }
      })
    },
    remove(i) {
      this.$emit('remove', i)
    },
  },
}
</script>

<style lang="scss">
.form-files-list {
  margin-top: 15px;

  .file + .file {
    margin-top: 15px;
  }

  .folders-select {
    margin-top: 16px;
  }

  .file {
    display: block;
    position: relative;

    &__content {
      display: flex;
      align-items: center;
      padding-right: 14px;
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 35px;
      height: 35px;
      background: rgba(204, 215, 230, 0.3);
      border-radius: 10px;
      flex-shrink: 0;
      margin-right: 10px;
    }

    .name {
      font-weight: 400;
      font-size: 15px;
      line-height: 127.5%;
      color: #474747;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: 40px;
    }

    .remove {
      position: absolute;
      right: 0;
      top: 9px;
      width: 13px;
      height: 13px;
      cursor: pointer;
      transition: all 0.25s;

      &:hover {
        opacity: 0.5;
      }
    }
  }

  &--folder {
    .file {
      padding: 16px;
      border: 1px solid #F0F3F7;
      border-radius: 10px;
    }

    .remove {
      right: 16px !important;
      top: 16px !important;
    }
  }
}
</style>
